import cx from 'classnames';
import { ReactNode, ReactNodeArray } from 'react';

import './Table.scss';

type TableDirection = 'horizontal' | 'vertical';

interface TableProps {
  cellClassName: string;
  className: string;
  direction: TableDirection;
  emptyDataRow: ReactNode;
  headClassName: string;
  rowClassName: string;
  theme: string;
  titles: ReactNodeArray;
  values: Array<ReactNodeArray>;
}

const defaultProps = {
  cellClassName: '',
  className: '',
  direction: 'horizontal',
  emptyDataRow: '',
  headClassName: '',
  rowClassName: '',
  theme: '',
  titles: [],
  values: [],
};

function Table({
  cellClassName,
  className,
  direction,
  emptyDataRow,
  headClassName,
  rowClassName,
  theme,
  titles,
  values,
}: TableProps) {
  const tableClassName = cx('Table', {
    [`Table--${direction}`]: direction,
    [`Table--theme-${theme}`]: theme,
    [className]: className,
  });

  switch (direction) {
    case 'horizontal':
      return (
        <table className={tableClassName}>
          <tbody>
            <tr>
              {titles.map((title, index) => (
                <th
                  className={cx('Table__head', headClassName)}
                  key={index} // eslint-disable-line react/no-array-index-key
                >
                  {title}
                </th>
              ))}
            </tr>
            {values.length === 0 && emptyDataRow ? (
              <tr className={cx('Table__row', rowClassName)}>
                <td className={cx('Table__cell', cellClassName)} colSpan={titles.length}>
                  {emptyDataRow}
                </td>
              </tr>
            ) : (
              values.map((value, index) => (
                <tr
                  className={cx('Table__row', rowClassName)}
                  key={index} // eslint-disable-line react/no-array-index-key
                >
                  {value?.map((cellValue, cellIndex) => (
                    <td
                      className={cx('Table__cell', cellClassName)}
                      key={cellIndex} // eslint-disable-line react/no-array-index-key
                    >
                      {cellValue}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      );
    case 'vertical':
    default:
      return (
        <table className={tableClassName}>
          <tbody>
            {values.length === 0 && emptyDataRow ? (
              <tr className={cx('Table__row', rowClassName)}>
                <td className={cx('Table__cell', cellClassName)}>{emptyDataRow}</td>
              </tr>
            ) : (
              titles.map((title, titleIndex) => (
                <tr
                  className={cx('Table__row', rowClassName)}
                  key={titleIndex} // eslint-disable-line react/no-array-index-key
                >
                  <th className={cx('Table__head', headClassName)}>{title}</th>
                  {values.map((value, index) => (
                    <td
                      className={cx('Table__cell', cellClassName)}
                      key={index} // eslint-disable-line react/no-array-index-key
                    >
                      {value && value[titleIndex]}
                    </td>
                  ))}
                </tr>
              ))
            )}
          </tbody>
        </table>
      );
  }
}

Table.defaultProps = defaultProps;

export default Table;
